const initialState = {
    userInfo: {},
    isloggedIn: false,
    userId: '',
    token: '',
    role: '',

};

const loginReducer = (state = initialState, action) => {

    switch (action.type) {
        case "LOGIN_SUCCESS":
            return {
                ...state,
                userId: action.payload.id,
                token: action.payload.accessToken,
                userInfo: action.payload,
                isloggedIn: !!action.payload.accessToken,
                role: action.payload.role,
            };

        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};

export default loginReducer;